<template>
  <b-list-group-item v-if="dataModal.dataItem.safe">
    <div class="font-weight-bold text-primary">
      Kasa Hesabı
    </div>
    <div>{{ dataModal.dataItem.safe }}</div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'SafeAccount',
  components: {
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/transferModal']
    },
  },
}
</script>
